import { CalendarOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute, useLocation } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/workload-manager/tasks')({
    component: Tasks,
});

function Tasks() {
    const orgId = useOrgId();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const isCalendarView = pathname.includes('/workload-manager/tasks/calendar');

    return (
        <PageController route={Route}>
            <Tabs
                primaryActionAddon={
                    isCalendarView ? (
                        <Button.Add.Link
                            to="/console/$orgId/workload-manager/tasks/calendar/add"
                            params={{ orgId }}
                            search={(prev) => ({
                                ...prev,
                                view: prev.view === 'day' || prev.view === 'week' ? prev.view : 'month',
                            })}
                            label="New task"
                            variant="primary"
                        />
                    ) : (
                        <Button.Add.Link
                            to="/console/$orgId/workload-manager/tasks/list/add"
                            params={{ orgId }}
                            search={(prev) => prev}
                            label="New task"
                            variant="primary"
                        />
                    )
                }
                type="inner"
                items={[
                    {
                        icon: <UnorderedListOutlined />,
                        label: 'List view',
                        to: '/console/$orgId/workload-manager/tasks/list',
                        onNavigate(options, e) {
                            navigate(
                                {
                                    to: '/console/$orgId/workload-manager/tasks/list',
                                    params: { orgId },
                                    search(prev) {
                                        return prev;
                                    },
                                    ...options,
                                },
                                e,
                            );
                        },
                    },
                    {
                        icon: <CalendarOutlined />,
                        label: 'Calendar view',
                        to: '/console/$orgId/workload-manager/tasks/calendar',
                        onNavigate(options, e) {
                            navigate(
                                {
                                    to: '/console/$orgId/workload-manager/tasks/calendar',
                                    params: { orgId },
                                    search() {
                                        return {
                                            view: 'month' as const,
                                            date: new Date(),
                                        };
                                    },
                                    ...options,
                                },
                                e,
                            );
                        },
                    },
                ]}
            />
        </PageController>
    );
}
